export default __webpack_public_path__ + "static/media/statsImage4 square updated.4c8e6c3a.svg";